/* istanbul ignore file */

export const FILTER_EVENTS = {
  FILTER_APPLIED: 'Filter Applied',
  FILTER_REMOVED: 'Filter Removed',
  ALL_FILTERS_CLEARED: 'All Filters Cleared',
} as const

export type FilterEventName = (typeof FILTER_EVENTS)[keyof typeof FILTER_EVENTS]
